/* eslint-disable no-undef */
import { ActivationCodesRepository, AppIntegrationsRepository, PaymentTypesRepository, TransactionsRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';

angular.module('controllers').controller(
    'AddPayment',
    (
        $scope, $stateParams, Util, ActivationCodeRestService,
        TransactionRestService, PaymentTypesRestService,
    ) => {

        $scope.iframeWidth = window.innerWidth;
        $scope.iframeWidth = window.innerHeight;

        $scope.activationCode = ActivationCodesRepository.getById($stateParams.resourceId);
        $scope.shopUrl = `${$scope.activationCode.attributes.add_payment_details_link}&x-a-source=cw`;
        $scope.app = AppIntegrationsRepository.getById($scope.activationCode.attributes.app);
        $scope.brandName = CWCONFIG.partnerConfig.name;

        const mixpanelPayload = {
            Source: 'Subscriptions',
            Modal: 'Add Payment Confirmation Modal',
            Product: $scope.app.attributes.name,
            'Product ID': $scope.app.id,
            Page: Util.getPageName(),
        };

        Mixpanel.send('ConnectWeb Modal Open ', mixpanelPayload);

        $scope.closeModal = () => {

            Util.closeModal();

        };

        $scope.onIframeError = (error) => {

            clearInterval($scope.fallbackInterval);

            const mixpanelDetails = {
                'Error object data': error,
            };

            Mixpanel.send('ConnectWeb Add Payment Error', mixpanelDetails);

            if (!$scope.error) {

                // TODO: Check status code in eventData
                $scope.error = true;
                Util.closeModal();

            }

        };

        $scope.onIframeReady = () => {

            if (!$scope.cartIframeReady) {

                const mixpanelDetails = {
                    Source: 'Subscriptions',
                    Modal: 'Add Payment Cart Iframe Modal',
                    Product: $scope.app.attributes.name,
                    'Product ID': $scope.app.id,
                    Page: Util.getPageName(),
                };

                Mixpanel.send('ConnectWeb Modal Open ', mixpanelDetails);

                $scope.cartIframeReady = true;
                $scope.showLoading = true;

            }

        };

        $scope.onIframeContentLoaded = () => {

            $scope.showLoading = false;
            $scope.$apply();

        };

        $scope.onPurchaseReady = (transactionId) => {

            const language = (CWCONFIG.language === 'de') ? 'de' : 'en';
            // link to support page
            $scope.supportUrl = `https://www.avira.com/${language}/support`;
            // reset of the world region
            $scope.paymentSupportUrlRegionCB = `https://shop.avira.com/30/?scope=cuseco&cfg=av092017_ppe&language=${language}`;

            $scope.transactionId = transactionId;

            $scope.showCartIframe = false;

            ActivationCodeRestService.getAllAsync().then((response) => {

                ActivationCodesRepository.replace(response.data.data);

            });

            if (!$scope.showSuccessModal) {

                const mixpanelDetails = {
                    Source: 'Subscriptions',
                    Modal: 'Add Payment Success Modal',
                    Product: $scope.app.attributes.name,
                    'Product ID': $scope.app.id,
                    Page: Util.getPageName(),
                };

                Mixpanel.send('ConnectWeb Modal Open ', mixpanelDetails);

                $scope.showSuccessModal = true;

                $scope.updateTransactionAndPaymentData();

            }

            clearInterval($scope.fallbackInterval);

        };

        $scope.updateTransactionAndPaymentData = async () => {

            // get payment when the purchase is finished
            await PaymentTypesRestService.getAllAsync().then((response) => {

                PaymentTypesRepository.replace(response.data.data);

            });

            // get transactions when the purchase is finished
            await TransactionRestService.getAllAsync().then((response) => {

                TransactionsRepository.replace(response.data.data);

            });
            eventManager.broadcast('purchase completed');

        };

        // Display cart iframe
        $scope.confirm = () => {

            const mixpanelDetails = {
                Modal: 'Add Payment Confirmation Modal',
                'Button Label': 'Continue',
                Product: $scope.app.attributes.name,
                'Product ID': $scope.app.id,
                'Subscription Runtime': $scope.activationCode.attributes.runtime,
                'Subscription Type': $scope.activationCode.attributes.subscription_type,
                Page: Util.getPageName(),
            };

            Mixpanel.send('ConnectWeb Modal Button Click', mixpanelDetails);
            $scope.showCartIframe = true;
            $scope.fallbackInterval = setInterval($scope.checkUserTransactions, 15000);

        };

        // add payment timeout error fallback
        $scope.checkUserTransactions = () => {

            TransactionRestService.getAllAsync().then((response) => {

                const transactions = response.data.data || [];
                const activationCodeID = $scope.activationCode.id || '';

                const transactionSucces = transactions
                    .find(transaction => transaction.relationships['activation-code'].data.id === activationCodeID);

                // check if the current activation code exists in any transaction
                if (transactionSucces) {

                    const mixpanelDetails = {
                        Source: 'Subscriptions',
                        Modal: 'Add Payment Success Modal - fallback function',
                        Product: $scope.app.attributes.name,
                        'Product ID': $scope.app.id,
                        Page: Util.getPageName(),
                    };

                    Mixpanel.send('ConnectWeb Modal Open ', mixpanelDetails);
                    $scope.transactionId = transactionSucces.attributes.payment_transaction_id;
                    $scope.showCartIframe = false;
                    $scope.showSuccessModal = true;

                    ActivationCodeRestService.getAllAsync().then((activationCodesResponse) => {

                        ActivationCodesRepository.replace(activationCodesResponse.data.data);

                    });

                    PaymentTypesRestService.getAllAsync().then((paymentTypesResponse) => {

                        PaymentTypesRepository.replace(paymentTypesResponse.data.data);

                    });

                    clearInterval($scope.fallbackInterval);

                }

            });

        };

        $scope.getModalWidth = () => {

            const defaultModalWidth = (750 - 2); // 2px for the border;
            const viewPortWidth = window.innerWidth;
            const clickAreaWidth = 32;

            return viewPortWidth > 830 ? defaultModalWidth : viewPortWidth - clickAreaWidth;

        };

        $scope.$on('$destroy', () => {

            clearInterval($scope.fallbackInterval);

        });

    },
);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/add-payment/add-payment.js